import UserPanel from './UserPanel';
import UserPanelContainer from './UserPanelContainer';

export {
  UserPanel,
  UserPanelContainer,
};
export default UserPanelContainer;